import { LocalDate } from '../../core/model/local-date';
import { ModelBase } from '../../core/model/model-base';

export class BrokerInformation extends ModelBase {
  calculationDate: LocalDate;
  rentalObjectId: string;
  fileName: string;
  typeOfCalculationDate: string;
}
